<script>
  /* Executable code section of the program */
  // Tools importation
  import {
    auth,
    doLogOut,
    getLocalData,
    getSpecificDocuments,
  } from "../apis/APIS";
  import { isProtectedRoute, userLocalData } from "../apis/storage";
  import { onAuthStateChanged } from "firebase/auth";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  //Auxiliary variables
  let isCoordinator = false;
  let isAdmin = false;
  let isContentLoaded = false;
  let pathname;

  // Definition of the window witdh
  const windowWidth = window.innerWidth;

  //Logged-in session verification
  //Initial function execution
  //Logged-in session verification
  onMount(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $userLocalData = await getSpecificDocuments(
          "users",
          "email",
          user.email
        );
        $isProtectedRoute = true;
        // Temporizador del loader
        setTimeout(async () => {
          isContentLoaded = true;

          //Role designation
          if ($userLocalData[0].userRole == "administrator") {
            isAdmin = true;
          } else if ($userLocalData[0].userRole == "coordinator") {
            isCoordinator = true;
          }
        }, 1000);
      } else {
        pathname = window.location.pathname.split("/")[1];
        if (pathname !== "resetPassword") {
          navigate("/");
        }
      }
    });
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isContentLoaded}
    <nav class="navBar">
      {#if windowWidth <= 700}
        <div class="menuBarContainer">
          <button
            class="btnMenu"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#staticBackdrop"
            aria-controls="staticBackdrop"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              fill="currentColor"
              class="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
              />
            </svg>
          </button>

          <div
            class="offcanvas offcanvas-start"
            data-bs-backdrop="static"
            tabindex="-1"
            id="staticBackdrop"
            aria-labelledby="staticBackdropLabel"
          >
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="staticBackdropLabel">Menu</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <h3>Hello, {$userLocalData[0].name || "Admininstraitor"} {$userLocalData[0].surname || ""}</h3>
              <div class="bodyContainer">
                <ul class="ulListMenu">
                  <div class="liMenuContainer">
                    <li class="liListMenu">
                      <a class="dropdown-item" href="/home"
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-globe-americas icon"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484q-.121.12-.242.234c-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z"
                          />
                        </svg> Home</a
                      >
                    </li>
                    <li class="liListMenu">
                      <a class="dropdown-item" href="/myProfile"
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-person-square icon"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                          <path
                            d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                          />
                        </svg> Profile</a
                      >
                    </li>
                    {#if isAdmin || isCoordinator}
                      <li class="liListMenu">
                        <a class="dropdown-item" href="/myChats"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-calendar3 icon"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z"
                            />
                            <path
                              d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                            />
                          </svg> MyChats</a
                        >
                      </li>
                      <li class="liListMenu">
                        <a class="dropdown-item" href="/socialattendees"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-people-fill icon"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                            />
                          </svg> Attendees</a
                        >
                      </li>
                      <li class="liListMenu">
                        <a class="dropdown-item" href="/eventhub"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-calendar-plus icon"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7"
                            />
                            <path
                              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                            />
                          </svg> Events Management</a
                        >
                      </li>
                      <li class="liListMenu">
                        <a class="dropdown-item" href="/meetingslis"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-journal-bookmark-fill icon"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z"
                            />
                            <path
                              d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                            />
                            <path
                              d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                            />
                          </svg> Meetings Management</a
                        >
                      </li>
                      <li class="liListMenu">
                        <a class="dropdown-item" href="/attendeeslist"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-person-fill icon"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
                            />
                          </svg>Attendee Management</a
                        >
                      </li>
                      {#if isAdmin}
                        <li class="liListMenu">
                          <a class="dropdown-item" href="/coordinatorslist"
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-person-rolodex icon"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                              />
                              <path
                                d="M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1z"
                              />
                            </svg> Coordinators Management</a
                          >
                        </li>
                      {/if}
                    {/if}
                  </div>

                  <div class="liSingoutContainer">
                    <li
                      class="liListMenu"
                      on:click={() => doLogOut()}
                      on:keypress={() => doLogOut()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        fill="currentColor"
                        class="bi bi-box-arrow-right icon"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                        />
                      </svg> Sing Out
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="logoContainer">
          <a href="/home">
            <img
              class="image"
              src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png"
              alt="NameLogo"
            />
          </a>
        </div>
      {:else}
        <div class="logoContainer">
          <a href="/home">
            <img
              class="image"
              src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png"
              alt="NameLogo"
            />
          </a>
        </div>
        <div class="menuBarContainer">
          <ul class="ulListMenu">
            <!-- 
        <li class="liListMenu liName">
          <h4 class="dropdown-item"> Hello, {$userLocalData[0].name} {$userLocalData[0].surname}</h4>
        </li> -->
            <li class="nav-item dropdown" style="margin-top:5px;">
              <a
                class="nav-link dropdown-toggle"
                href="a"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5>
                  Hello, {$userLocalData[0].name || "Admin"}
                  {$userLocalData[0].surname || ""}
                </h5>
              </a>
              <ul class="dropdown-menu">
                <li class="liListMenu">
                  <a class="dropdown-item" href="/home">Home</a>
                </li>
                <li class="liListMenu">
                  <a class="dropdown-item" href="/myProfile">Profile</a>
                </li>
                {#if isAdmin || isCoordinator}
                  <li class="liListMenu">
                    <a class="dropdown-item" href="/myChats">MyChats</a>
                  </li>
                  <li class="liListMenu">
                    <a class="dropdown-item" href="/socialattendees"
                      >Attendees</a
                    >
                  </li>
                  
                {/if}
              </ul>
            </li>
            {#if isAdmin || isCoordinator}
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="a"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Management
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="/eventhub"
                    >Events Management</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/meetingslis"
                    >Meetings Management</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/attendeeslist"
                    >Attendee Management</a
                  >
                </li>
                {#if isAdmin}
                  <li>
                    <a class="dropdown-item" href="/coordinatorslist"
                      >Coordinators Management</a
                    >
                  </li>
                {/if}
              </ul>
            </li>
            {/if}
            <!-- <li class="liListMenu">
              <a class="dropdown-item" href="/home">Home</a>
            </li>
            <li class="liListMenu">
              <a class="dropdown-item" href="/myProfile">Profile</a>
            </li> -->
            <!-- {#if isAdmin || isCoordinator}
              <li class="liListMenu">
                <a class="dropdown-item" href="/myChats">MyChats</a>
              </li>
              <li class="liListMenu">
                <a class="dropdown-item" href="/socialattendees">Attendees</a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="a"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Management
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="/eventhub"
                      >Events Management</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="/meetingslis"
                      >Meetings Management</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="/attendeeslist"
                      >Attendee Management</a
                    >
                  </li>
                  {#if isAdmin}
                    <li>
                      <a class="dropdown-item" href="/coordinatorslist"
                        >Coordinators Management</a
                      >
                    </li>
                  {/if}
                </ul>
              </li>
            {/if} -->
            <li
              class="liListMenu singOutBtn"
              on:click={() => doLogOut()}
              on:keypress={() => doLogOut()}
            >
              Sing Out<svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-box-arrow-right icon"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                />
              </svg>
            </li>
          </ul>
        </div>
      {/if}
    </nav>
  {/if}
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .navBar {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: white;
  }
  .menuBarContainer {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
  }
  .logoContainer {
    width: 50%;
    padding-left: 70px;
  }
  .image {
    width: 30%;
    height: auto;
    margin: 15px 0;
  }
  .ulListMenu {
    display: flex;
    flex-direction: row;
  }
  li {
    list-style: none;
    margin: 0 10px;
    padding: 10px 0;
    display: flex;
    align-items: center;
  }
  .icon {
    margin: 5px 10px;
  }
  a,
  .singOutBtn {
    display: flex;
    align-items: center;
  }
  .singOutBtn {
    margin-left: 10px;
  }
  a:hover {
    color: #ed2824;
    cursor: pointer;
  }
  .liListMenu:hover {
    cursor: pointer;
    color: #ed2824;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .menuBarContainer {
      width: 70%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .logoContainer {
      width: 30%;
      padding-left: 70px;
    }
    .ulListMenu {
      display: flex;
      align-items: center;
    }
    a {
      display: flex;
      align-items: center;
    }
    a:hover {
      color: black;
    }
    .image {
      width: 100%;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .menuBarContainer {
      width: 20%;
      height: 100%;
      display: flex;
      padding: 10px 0;
      z-index: 980;
    }
    .btnMenu {
      color: black;
      border-color: white;
      background-color: white;
      border-style: none;
    }
    .logoContainer {
      padding-left: 10px;
      width: 80%;
      display: flex;
      justify-content: flex-start;
    }
    .image {
      width: 70%;
    }
    .bodyContainer {
      height: 98%;
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 0;
    }
    .ulListMenu {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    li {
      width: 90%;
      font-size: 20px;
      margin: 20px 0;
      padding: 10px 0;
      border-bottom: 1px solid #ed2824;
    }
    .offcanvas-body {
      background-color: #f4f4f4;
    }
    .liMenuContainer {
      width: 100%;
    }
    .liSingoutContainer {
      width: auto;
    }
    .icon {
      color: black;
    }
  }

  /* End of the section */
</style>
